import { createFileRoute } from "@tanstack/react-router";

import { isAuditProject } from "@/core/lib/access";
import { redirectToClientOverview } from "@/core/lib/feature-guards";

export const Route = createFileRoute(
  "/_protected/auditor/clients/$id/_client-tabs/input-process/reconciliation",
)({
  beforeLoad: ({ context, params }) => {
    const organizationId = context.user?.organization?.id;

    if (!organizationId || !isAuditProject(context.active)) {
      redirectToClientOverview(params.id);
    }
  },
});
